import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'Map'*/ 'src/controllers/Map/Map'),
	loading: Loading,
});
